/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import checkForLocalStorage from 'utils/checkforlocalstorage';
import Alert from 'material/message/alert/alert';
import Link from 'material/ctas/link/link_container';

import injectSheet from 'react-jss';
import styles from 'material/message/pervasivemessage/pervasivemessage_styles'

/* ========== ~~~~~~~~~~ PERVASIVEMESSAGE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary

class PervasiveMessage extends Component {

    /*README: To add pervasive messages to various pages in the applications, simply add an object to the array below; use the template included in this 
    comment as reference to correctly set the object's properties. Note that the pages array will apply the message to all subpages of all elements; use
    the pagesExcluded array to specify which of these not to include. The pagesExcluded array also considers subpages of its elements. 
    {
            message: <div>Hello World!</div>,
            pages: ['dashboard/home, dashboard/account,...'],
            pagesExcluded: ['dashboard/account/paymentinfo'], 
            enabled: true,
    }
    */

    pervasiveMessages = () => {
        return [
            {
                message: <div>There is no Preferred Payment Method selected for your Account: without this, Insticator cannot pay you.{' '}
                    <Link type={`internal`}
                        action={`dashboard/account/paymentinfo`}
                        text={<b>Please add one here.</b>}
                        color={`primary`}
                        name={`preferredpaymentnotselected`} />
                </div>,
                pages: ['dashboard/home', 'dashboard/analytics/detail', 'dashboard/embeds', 'dashboard/account', 'dashboard/reports'],
                pagesExcluded: ['dashboard/account/paymentinfo', 'dashboard/embeds/management', 'dashboard/reports/detail'],
                enabled: this.props.paymentInfoReceived && !this.props.preferredPaymentType && this.props.paymentInfoPermitted,
                variant: 'neutral',
                icon: `exclamation-triangle`
            },
            {   title: 'New Update',
                message: <div>We’ve built an improved report builder.{' '}<Link type={`internal`}
                                                                                       action={`dashboard/reports`}
                                                                                       text={<b>Try it now!</b>}
                                                                                       color={`system`}
                                                                                       underline={true}
                                                                                       name={`preferredpaymentnotselected`} />

                </div>,
                pages: ['dashboard/home'],
                pagesExcluded: ['dashboard/account/paymentinfo', 'dashboard/embeds/management', 'dashboard/reports/detail'],
                enabled: checkForLocalStorage() && !window.localStorage.getItem('reportsOpened'),
                variant: 'primary',
                icon: 'bullhorn',
                close: true,
                handleClose: () => (checkForLocalStorage() && window.localStorage.setItem('reportsOpened', 'true'))
            }
        ]
    };

    hasMessage = () => {
        for (const message of this.pervasiveMessages()) {
            if (message.enabled && message.pages.filter((url) => this.props.currentPage.startsWith(url)).length > 0
            && message.pagesExcluded.filter((url) => this.props.currentPage.startsWith(url)).length == 0) {
                return true;
            }
        }
        return false;
    }

    getMessagesForPage = () => {
        return this.pervasiveMessages().map((currentMessage, index) => {
            if ((currentMessage.enabled && currentMessage.pages.filter((url) => this.props.currentPage.startsWith(url)).length > 0)
                && currentMessage.pagesExcluded.filter((url) => this.props.currentPage.startsWith(url)).length == 0) {
                return <Alert key={index} display={currentMessage.enabled} variant={currentMessage.variant} icon={currentMessage.icon} title={currentMessage.title} text={currentMessage.message} close={currentMessage.close} handleClose={currentMessage.handleClose}/>;
            }
        });
    }

    render() {
        return (
            this.hasMessage() ? <div className={`pervasivemessage ${this.props.classes.pervasivemessage}`}>
                {this.getMessagesForPage()}
            </div> : null
        )
    }
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PervasiveMessage);